import Box from "@mui/material/Box"
import Stack from "@mui/material/Stack"
import { useEffect, useState } from "react"

import TextInput from "@components/text_input"
import PhoneInput from "@components/text_input/sub_components/phone_input"

import { GRAY_COLOR, WATSAPP_ACTIVE } from "@constants/colors"
import {
  WhatsappFormData,
  useWhatsappPageContext
} from "@contexts/main/whatsapp_page_context"
import { useParams } from "react-router-dom"
import styles from "./styles"

export default function WhatsappBuilderPage() {
  const { translate, control, whatsappData, reset } = useWhatsappPageContext()

  const { id } = useParams()

  const [statusKey, setStatusKey] = useState<number>(0)
  const [statusDisabled, setStatusDisabled] = useState(false)

  const selected = whatsappData?.find((item) => item._id === id)

  useEffect(() => {
    if (selected && whatsappData) {
      reset?.({
        displayName: selected?.name || "",
        company: selected?.customer.companyName || "",
        status: selected?.status,
        appName: selected?.appName || "",
        appID: selected?.appId || "",
        appToken: selected?.appToken || "",
        appKey: selected?.apiKey || "",
        productTemplate: selected?.product_template_id || "",
        phone: {
          value: selected?.channelId ?? "",
          dialCode: selected?.channelId?.substring(0, 3),
          countryCode: "tr"
        }
      })
      if (selected?.status) {
        setStatusDisabled(true)
      } else {
        setStatusDisabled(false)
      }
      setStatusKey((prev) => prev + 1)
    }
  }, [whatsappData, selected])

  return (
    <Stack sx={styles.containerWidth} p={2}>
      <Stack gap={1}>
        <TextInput<WhatsappFormData>
          key={statusKey}
          type="select"
          name="status"
          control={control}
          label={translate("status")}
          placeholder={translate("enter")}
          selectOptions={[
            {
              label: translate("approved"),
              value: true,
              color: WATSAPP_ACTIVE
            },
            {
              label: translate("waiting_for_approved"),
              value: false,
              color: GRAY_COLOR
            }
          ]}
          required
          disabled={statusDisabled}
        />
        <TextInput<WhatsappFormData>
          type="text"
          name="company"
          control={control}
          label={translate("company")}
          placeholder={translate("enter")}
          required
          disabled
        />
        <TextInput<WhatsappFormData>
          type="text"
          name="displayName"
          control={control}
          label={translate("display_name")}
          placeholder={translate("enter")}
          required
        />
        <Box>
          <PhoneInput<WhatsappFormData>
            style={{ width: "800px" }}
            type="text"
            name="phone"
            control={control}
            label={translate("phone")}
            placeholder="1"
            required
            disabled
          />
        </Box>
        <TextInput<WhatsappFormData>
          type="text"
          name="appName"
          control={control}
          label={translate("app_name")}
          placeholder={translate("enter")}
          required
        />
        <TextInput<WhatsappFormData>
          type="text"
          name="appID"
          control={control}
          label={translate("app_id")}
          placeholder={translate("enter")}
          required
        />
        <TextInput<WhatsappFormData>
          type="text"
          name="appToken"
          control={control}
          label={translate("app_token")}
          placeholder={translate("enter")}
          required
        />
        <TextInput<WhatsappFormData>
          type="text"
          name="appKey"
          control={control}
          label={translate("api_key")}
          placeholder={translate("enter")}
          required
        />
        <TextInput<WhatsappFormData>
          type="text"
          name="productTemplate"
          control={control}
          label={translate("product_template_id")}
          placeholder={translate("enter")}
          required
        />
      </Stack>
    </Stack>
  )
}
